module.exports = __webpack_public_path__ + "fonts/DINRoundPro.woff?87d57cb1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINRoundPro.woff
// module id = 849
// module chunks = 0 1 2 3 4 5